/**
 * Single source of truth for the API origin.
 *
 * Production Pages (`frontend/.env.production`) and Preview bake
 * `VITE_API_URL=/`. A trailing slash collapses to an empty base, so API paths
 * stay same-origin and the Pages Function proxies `/api` to Railway. An
 * absolute `VITE_API_URL` still prefixes every path. In local dev the variable
 * is empty and the Vite proxy serves `/api` from the SPA origin.
 *
 * Kept free of axios/store imports so it can be used anywhere (and survives
 * tests that mock `@/lib/api`).
 */
export const API_BASE: string = ((import.meta.env.VITE_API_URL as string | undefined) || '').replace(/\/+$/, '')

/** Prefix an API-relative path (`/api/...`, `/uploads/...`) with the API origin. */
export function apiUrl(path: string): string {
  return `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`
}

/**
 * Resolve a URL returned by the backend. Absolute (S3/CDN), blob:, and data:
 * URLs pass through; server-relative paths (local-disk uploads such as
 * `/uploads/...` or `uploads/...`) are resolved against the API origin.
 */
export function resolveApiUrl(url: string): string
export function resolveApiUrl(url: string | null | undefined): string | undefined
export function resolveApiUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined
  if (/^(https?:|blob:|data:)/i.test(url)) return url
  return apiUrl(url)
}
